module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/4_b40f862054cf1afc94fc9bd90784dd3a.png";